import css from "styled-jsx/css";
import { MOBILE_QUERY_MAX_WIDTH } from "/constants/vp-sizes";

export const componentStyles = css.global`
  .competitors-comparison-table {
    text-align: center;
    margin-top: 50px;

    .competitors-comparison-title {
      font-size: 2.2vw;
      margin-bottom: 20px;
      font-weight: 500;
    }

    .competitors-comparison-subtitle {
      font-size: 1.4vw;
      font-weight: 300;
      line-height: 1.3;
      margin-bottom: 20px;
    }

    .table-wrapper {
      padding: 50px 100px;

      .table-header {
        padding-bottom: 20px !important;

        .vs-cell {
          font-size: 26px;
          font-weight: 400;
        }
      }

      .table-row {
        display: flex;
        padding: 0px 30px;

        .table-cell {
          flex: 1 1;
          height: 80px;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .first-cell {
          justify-content: left;
        }

        .monday-logo-wrapper {
          width: 100%;

          img {
            width: 80%;
            max-width: 200px;
          }
        }

        .competitor-logo-wrapper {
          width: 100%;

          img {
            width: 80%;
            max-width: 200px;
          }
        }
      }
    }

    .mobile-table-wrapper {
      display: none;
    }

    @media (max-width: ${MOBILE_QUERY_MAX_WIDTH}) {
      .competitors-comparison-titles-wrapper {
        padding: 0px 20px;
        width: 80%;
        margin: 0px auto;

        .competitors-comparison-title {
          font-size: 28px;
          text-align: left;
          line-height: 1.3;
        }

        .competitors-comparison-subtitle {
          font-size: 16px;
          text-align: left;
          line-height: 1.5;
        }
      }

      .table-wrapper {
        display: none;
      }

      .mobile-table-wrapper {
        display: block;
        margin: 50px 0px;

        .table-header {
          display: flex;
          padding: 10px 0px;

          .monday-logo-wrapper,
          .competitor-logo-wrapper {
            width: 100%;

            img {
              width: 80%;
            }
          }
        }
      }
    }
  }
`;
